/* eslint-disable max-lines */
import React, { useEffect, useState, useImperativeHandle } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { Select, Loader } from 'sa-ui';
import queryString from 'query-string';

import { promisify } from '../../../app/actions';
import * as actions from '../../reportsActions';
import * as detailsActions from '../reportApplicationDetailsActions';

import messages from '../reportApplicationDetailsMessages';

import ReportCardStudent from './ReportCardStudent';
import Chart from '../../GenericReportBarChart';
import AssessmentCycleTable from '../../AssessmentCycleTable';
import HitPerformancePerAbility from '../../HitPerformancePerAbility';

import StudentPerformancePerGrade from './StudentPerformancePerGrade';

import reportCardMessages from './reportCardMessages';
import reportMessages from '../../reportsMessages';
import * as helpers from '../../reportHelpers';

import '../../ReportsCommon.scss';
import './ReportCardContainer.scss';

function toCurricularPerformanceSeries(gradeByDiscipline) {
  if (gradeByDiscipline.length === 0) return [];
  return gradeByDiscipline.map((g, index) => ({
    name: g.name,
    data: g.average,
    courseAverage: g.courseAverage,
    index,
  }));
}

function toPerformanceSeries(gradeReportStudent, intl) {
  if (Object.keys(gradeReportStudent).length === 0) return [];
  return [
    {
      name: intl.formatMessage(messages.studentGrade),
      data: gradeReportStudent.studentGrade,
    },
    {
      name: intl.formatMessage(messages.studentGroupAverage),
      data: gradeReportStudent.studentGroupAvg,
    },
    {
      name: intl.formatMessage(messages.schoolAverage),
      data: gradeReportStudent.schoolAvg,
    },
    {
      name: intl.formatMessage(messages.overallAveragePerformance),
      data: gradeReportStudent.overallAvg,
    },
  ];
}

function getInitialRankingLimit() {
  const params = queryString.parse(window.location.search.replace('?', ''));
  return params.rankingLimit ? Number(params.rankingLimit) : 10;
}

const ReportCardContainer = (props) => {
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [socketMessage, setSocketMessage] = useState('');
  const schoolOptions = helpers.getFASchoolOptions(props.filtersComponents.schools);
  const classesOptions = helpers.getFComponentsClassesOptions(props.filtersComponents.courses);
  const studentsOptions = helpers.getFComponentsStudentsOptions(props.filtersComponents.students);
  const [evaluationSelected, setEvaluationSelected] = useState([]);

  const [rankingLimit, setRankingLimit] = useState(getInitialRankingLimit);

  const [filter, setFilter] = useState(queryString.parse(window.location.search.replace('?', '')));
  const [studentInfo, setStudentInfo] = useState({});

  async function handleAPIs(idCSchool, idESCourse, idESUser) {
    await setLoading(true);
    try {
      await props.getESGradeByDiscipline({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
        idESUser,
      });
      await props.getESGradeStudentQuestions({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
        idESUser,
      });
      await props.getESGradeReportStudent({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
        idESUser,
      });
      await props.getESQuestionsDetailsByComponents({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
        idESUser,
      });
      await props.getESGradeDetailAlternativeReport({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
        idESUser,
      });
      await props.getESEvaluationsCicleStudent({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
        idESUser,
      });
      await props.getESGradeDetailByStudent({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
        idESUser,
      });
    } finally {
      setLoading(false);
    }
  }

  async function selectFilter(idCSchool, idESCourse, idESUser) {
    setFilter({ ...filter, idCSchool });
    try {
      setLoading(true);
      await props.getESFiltersComponents({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
      });
    } finally {
      if (idCSchool && idESCourse && idESUser) {
        //   handleAPIs(idCSchool, idESCourse, idESUser);
      } else {
        setLoading(false);
      }
    }
  }

  function clearFilters() {
    setFilter({});
  }

  function handleChangeSchool(event) {
    setFilter({
      ...filter,
      idCSchool: event.target.value,
      idESCourse: undefined,
      idESUser: undefined,
    });
  }

  function handleChangeCourse(event) {
    setFilter({
      ...filter,
      idESCourse: event.target.value,
      idESUser: undefined,
    });
  }

  function handleChangeStudent(event) {
    setFilter({
      ...filter,
      idESUser: event.target.value,
    });
  }

  async function handleBatchPdf() {
    setLoading(true);
    setLoadingMessage(props.intl.formatMessage(reportCardMessages.loadingMessage));
    const reportApplicationID = window.location.pathname.split('/')[3];
    const pdfs = studentsOptions.map((option) => ({
      filename: `${props.intl.formatMessage(reportCardMessages.filenameStudentPdf)}_${
        option.value
      }_${helpers.normalizeStudentName(option.label)}.pdf`,
      host: `${window.location.protocol}//${window.location.host}`,
      path: window.location.pathname,
      params: { ...filter, idESUser: option.value, expanded: true, rankingLimit: 1000 },
    }));

    const totalPdfs = pdfs.length;
    setSocketMessage(`Gerando arquivo 1 de ${totalPdfs}`);

    try {
      const response = await props.generateBatchPdf({
        filename: `${props.intl.formatMessage(reportCardMessages.filenameBatchStudentPdf)}-${
          props.filtersComponents.idESCourse
        }.zip`,
        pdfs,
        idCSchool: filter.idCSchool,
        idESCourse: filter.idESCourse,
        token: props.token,
        reportApplicationID,
      });

      const requestId = response.id;
      const t = setInterval(async () => {
        const response = await props.generateEvaluationAnswerSheetsFilesStatus({
          id: requestId,
        });
        const status = response.data.content;
        if (status > totalPdfs) {
          clearInterval(t);
          setLoadingMessage('Cartões gerados. Criando arquivo para download...');
          handleDownloadPdf(requestId);
          setTimeout(() => {
            setLoading(false);
            setLoadingMessage('');
          }, 2000);
        } else {
          const currentStatus = status || 1;
          setSocketMessage(`Gerando arquivo ${currentStatus} de ${totalPdfs}`);
        }
      }, 10000);
    } finally {
      // Finalização opcional
    }
  }

  const handleDownloadPdf = (requestId) => {
    top.location.href = `${process.env.SM_API_NODE_URL}/reports/capture/pdf/multiple/download?id=${requestId}`;
  };

  useEffect(() => {
    props.getGroups();
  }, []);

  useEffect(() => {
    if (filter.idCSchool || filter.idESCourse || filter.idESUser) {
      selectFilter(filter.idCSchool, filter.idESCourse, filter.idESUser);
    } else if (!filter.idCSchool && !filter.idESCourse && !filter.idESUser) {
      props.getESFiltersComponents({
        idEvaluation: props.idEvaluation,
      });
    }
  }, [props.idEvaluation, filter.idCSchool, filter.idESCourse, filter.idESUser]);

  useEffect(() => {
    if (filter.idCSchool && filter.idESCourse && filter.idESUser) {
      handleAPIs(filter.idCSchool, filter.idESCourse, filter.idESUser);
    }
  }, [filter.idCSchool, filter.idESCourse, filter.idESUser]);

  useEffect(() => {
    if (props.filtersComponents) {
      if (props.filtersComponents.length === 1) {
        setFilter({
          ...filter,
          idCSchool: props.filtersComponents[0].idCSchool,
        });
      }
      const schoolSelected = schoolOptions.find((s) => s.value === filter.idCSchool) || {};
      const courseSelected = classesOptions.find((c) => c.value === filter.idESCourse) || {};
      const studentSelected = studentsOptions.find((s) => s.value === filter.idESUser) || {};

      setStudentInfo({
        schoolName: schoolSelected.label,
        courseName: courseSelected.label,
        studentName: studentSelected.label,
      });
    }
  }, [props.filtersComponents]);

  useEffect(
    () => () => {
      setFilter(queryString.parse(window.location.search.replace('?', '')));
      setStudentInfo({});
    },
    [],
  );

  useEffect(() => {
    if (
      props.gradeReportStudent &&
      props.gradeByDiscipline &&
      props.alternativeReport &&
      props.cicleStudent
    ) {
      setTimeout(() => window.dispatchEvent(new CustomEvent('app-ready')));
    }
  }, [
    props.gradeReportStudent,
    props.gradeByDiscipline,
    props.alternativeReport,
    props.cicleStudent,
  ]);

  useImperativeHandle(props.forwardRef, () => ({
    getFilter: () => filter,
  }));

  const performanceSeries = toPerformanceSeries(props.gradeReportStudent, props.intl);
  const curricularPerformanceSeries = toCurricularPerformanceSeries(
    props.gradeByDiscipline,
    props.intl,
  );

  return (
    <div>
      <Loader show={loading} message={loadingMessage} batchMessage={socketMessage} />

      <div>
        <h6 className="filter subtitle mt-3 d-print-none">
          <i className="pe-7s-filter" />
          <FormattedMessage {...messages.filters} />
          <FormattedMessage {...messages.clear}>
            {(txt) => (
              <button type="button" className="btn btn-primary btn-sm ml-3 " onClick={clearFilters}>
                {txt}
              </button>
            )}
          </FormattedMessage>
        </h6>
        <Row className="align-items-center">
          <Col md={4}>
            <Select
              containerClassName="mt-0"
              nullable
              name="idCSchool"
              onChange={handleChangeSchool}
              value={filter.idCSchool}
              options={schoolOptions}
              placeholder={props.intl.formatMessage(reportMessages.school)}
            />
          </Col>
          <Col md={4}>
            <Select
              containerClassName="mt-0"
              disabled={!filter.idCSchool}
              nullable
              name="idCourse"
              value={filter.idESCourse}
              onChange={handleChangeCourse}
              options={classesOptions}
              placeholder={props.intl.formatMessage(reportMessages.class)}
            />
          </Col>
          <Col md={4}>
            <Select
              containerClassName="mt-0"
              disabled={!filter.idESCourse}
              nullable
              name="idESUser"
              value={filter.idESUser}
              onChange={handleChangeStudent}
              options={studentsOptions}
              placeholder={props.intl.formatMessage(reportMessages.student)}
            />
          </Col>
        </Row>
      </div>

      <div id="divToPDF" className="divToPDF">
        <div className="report-card--actions-container d-print-none">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleBatchPdf}
            disabled={!filter.idESCourse}
          >
            {props.intl.formatMessage(reportCardMessages.batchPdf)}
          </button>
        </div>
        {filter.idCSchool && filter.idESCourse && filter.idESUser ? (
          <div>
            {studentInfo.studentName && (
              <Row className="mt-3">
                <Col xs={12}>
                  <ReportCardStudent {...props.gradeDetailStudent} {...studentInfo} />
                </Col>
              </Row>
            )}
            <Row className="mt-3">
              <Col xs={12}>
                <StudentPerformancePerGrade
                  items={props.studentQuestions}
                  title={props.intl.formatMessage(reportCardMessages.studentPerformanceByQuestion)}
                  answer={props.intl.formatMessage(reportCardMessages.answer)}
                  correct={props.intl.formatMessage(reportCardMessages.correct)}
                  limit={rankingLimit}
                />
              </Col>
            </Row>
            {performanceSeries.length > 0 && (
              <Row className="mt-3">
                <Col xs={12}>
                  <Chart
                    title={props.intl.formatMessage(messages.performanceComparison)}
                    series={performanceSeries}
                    barWidth={25}
                  />
                </Col>
              </Row>
            )}
            {curricularPerformanceSeries.length > 0 && (
              <Row className="mt-3">
                <Col xs={12}>
                  <Chart
                    title={props.intl.formatMessage(messages.studentPerformanceByComponent)}
                    series={curricularPerformanceSeries}
                    barWidth={25}
                  />
                </Col>
              </Row>
            )}
            {props.alternativeReport && props.alternativeReport.length > 0 && (
              <Row className="mt-3">
                <Col xs={12}>
                  <HitPerformancePerAbility items={props.alternativeReport} limit={rankingLimit} />
                </Col>
              </Row>
            )}
            {props.cicleStudent && props.cicleStudent.length > 0 && (
              <Row className="mt-3">
                <Col xs={12}>
                  <AssessmentCycleTable
                    items={props.cicleStudent}
                    limit={rankingLimit}
                    history={props.history}
                    idCSchool={filter.idCSchool}
                    idESCourse={filter.idESCourse}
                    idESUser={filter.idESUser}
                  />
                </Col>
              </Row>
            )}
          </div>
        ) : (
          <div style={{ marginTop: '20px' }} className="d-print-none">
            <h6>{props.intl.formatMessage(reportCardMessages.loadReportsCard)}</h6>
          </div>
        )}
      </div>
    </div>
  );
};

ReportCardContainer.propTypes = {};

const mapStateToProps = ({ reports, reportApplicationDetails, app }, { match }) => ({
  ...reports,
  ...reportApplicationDetails,
  ...match.params,
  token: app.cookieToken,
  permission: app.permission,
  user: app.user,
});

export default compose(
  injectIntl,
  withRouter,
  connect(
    mapStateToProps,
    promisify(
      { ...actions, ...detailsActions },
      {
        include: [
          'generateBatchPdf',
          'getESFiltersComponents',
          'getESGradeByDiscipline',
          'getESGradeStudentQuestions',
          'getESGradeReportStudent',
          'getESQuestionsDetailsByComponents',
          'getESGradeDetailAlternativeReport',
          'getESEvaluationsCicleStudent',
          'getESGradeDetailByStudent',
          'generateEvaluationAnswerSheetsFilesStatus',
        ],
      },
    ),
  ),
)(ReportCardContainer);
